import { request } from './request';

export const createStripeCustomer = (body) => {
  const amount =
    Number(body.doctorFee || 0) +
    Number(body.patientFee || 0) +
    Number(body.amount || 0);

  return request(
    `stripe/customer`,
    { method: 'POST', body },
    `Patient will be charged €${amount}!`,
  );
};

export const createStripeAccount = (body) => {
  return request(`stripe/account`, { method: 'POST', body });
};

export const getPaymentIntentByStripeId = (stripeId) => {
  return request(`stripe/paymentIntent/${stripeId}`, { method: 'GET' });
};
